import { ACCOUNT } from '../../reduxs'
import { LIST_LANGUAGE, setLocalStorage, getLocalStorage, colorThemeSelector } from '../../helpers'

const initialState = {
  user: {
    id: null,
    username: '',
    type: null,
    defaultName: '',
    companyId: 0,
    language: 'EN',
    accountLockTime: 5,
    checkInTime: 15,
    minuteStep: 15,
    startOperatingTime: '00:00:00',
    endOperatingTime: '23:59:59'
  },
  profile: null,
  permission: null,
  language: getLocalStorage('booking-language') ? getLocalStorage('booking-language') : LIST_LANGUAGE[0],
  isFCMRegistered: false,
  isLogin: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ACCOUNT.actionType.SELECT_LIST_LANGUAGE:
      setLocalStorage('booking-language', action.data)
      return {
        ...state, language: action.data
      }

    case ACCOUNT.actionType.SAVE_ACCOUNT:
      const { isLogin, ...data } = action.data
      const { colorTheme, themeConfig } = data
      const colorThemePalette = colorThemeSelector(colorTheme)
      
      let parsedThemeConfig = themeConfig
      if (typeof parsedThemeConfig === 'string') {
        try {
          parsedThemeConfig = JSON.parse(parsedThemeConfig)
        } catch (e) {
          parsedThemeConfig = {}
        }
      }

      return {
        ...state,
        user: {
          ...initialState.user,
          ...data,
          accessToken: undefined,
          colorThemePalette,
          themeConfig: parsedThemeConfig,
        },
        language: action.data.language,
        permission: action.data.permission,
        isLogin,
      }

    case ACCOUNT.actionType.CLEAR_ALL_DATA:
      return {
        ...initialState
      }
      
    case ACCOUNT.actionType.SAVE_PROFILE:
      return {
        ...state, profile: { ...action.data }
      }

    case ACCOUNT.actionType.CREATE_FCM:
      return {
        ...state, ...action.data
      }

    default:
      return state
  }
}
